import React, { Component } from 'react';
import { connect } from "react-redux";
import i18n from "../../../i18next";
import { Button, Col, Form, FormGroup, FormFeedback, Input, Label, Row } from "reactstrap";
import MaterialIcon from "material-icons-react";

import { negativeIntegersValidation } from "../../../utils/CommonUtils";
import { generatePromotionCodes } from "../../../actions";

class PromotionPromoCodesScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            promotionId: null,
            promoCodeUsageType: '',
            promoCodeFromExternalSource: true,
            promoCodeValues: '',
            promoCodeValuesFromExternalSource: '',
            promoCodesGeneratedValues: '',
            promoCodeQuantityValue: null,
            fieldsDisabled: false,
            invalidForm: false,
            stateAlreadyCopiedFromProps: false,
            oneTimeDiscount: false,
            oneTimePerCustomer: false
        };

        this.changePromoCodeFromExternalSourceState = this.changePromoCodeFromExternalSourceState.bind(this);
        this.changeFieldState = this.changeFieldState.bind(this);
        this.generatePromoCodes = this.generatePromoCodes.bind(this);
    }

    copyStateFromProps() {
        console.log('copyStateFromProps ', this.props.oneTimePerCustomer)
        const { promotionId, selectedPromotion } = this.props;

        if (promotionId !== undefined && promotionId !== null &&
            (!this.state.stateAlreadyCopiedFromProps || promotionId !== this.state.promotionId)) {

            const promoCodeQuantityValueCondition = (selectedPromotion.promoCodeValues !== undefined && selectedPromotion.promoCodeValues !== null
                && selectedPromotion.promoCodeValues.length > 0 && !selectedPromotion.promoCodeFromExternalSource);
            const promoCodeQuantityValueConditionTwo = (this.state.promoCodeValues !== undefined && this.state.promoCodeValues !== null && this.state.promoCodeValues.length > 0);

            let promoCodeQuantityValue;

            if (promoCodeQuantityValueCondition) {
                promoCodeQuantityValue = selectedPromotion.promoCodeValues.split(",").length;
            } else if (promoCodeQuantityValueConditionTwo) {
                promoCodeQuantityValue = this.state.promoCodeValues.split(",").length;
            } else {
                promoCodeQuantityValue = ''
            }

            this.setState({
                promotionId: (selectedPromotion) ? selectedPromotion.id : -1,
                promoCodeUsageType: (selectedPromotion.promoCodeUsageType) ? selectedPromotion.promoCodeUsageType : '',
                promoCodeFromExternalSource: (selectedPromotion.promoCodeFromExternalSource !== undefined && selectedPromotion.promoCodeFromExternalSource !== null) ? selectedPromotion.promoCodeFromExternalSource : true,
                promoCodeValuesFromExternalSource: (selectedPromotion && selectedPromotion.promoCodeFromExternalSource) ? selectedPromotion.promoCodeValues : '',
                promoCodesGeneratedValues: (selectedPromotion && !selectedPromotion.promoCodeFromExternalSource) ? selectedPromotion.promoCodeValues : '',
                promoCodeValues: (selectedPromotion) ? selectedPromotion.promoCodeValues : '',
                promoCodeQuantityValue: promoCodeQuantityValue,
                stateAlreadyCopiedFromProps: true,
                fieldsDisabled: (selectedPromotion.id !== -1) ? true : false,
                oneTimeDiscount: this.props.oneTimeDiscount,
                oneTimePerCustomer: this.props.oneTimePerCustomer
            });

            if (this.props.promoCodes !== undefined && this.props.promoCodes !== null && this.props.promoCodes.length > 0
                && !this.state.promoCodeFromExternalSource && (!this.state.stateAlreadyCopiedFromProps || this.props.promoCodes.length > this.state.promoCodesGeneratedValues.length)) {

                this.setState({
                    ...this.state,
                    promoCodesGeneratedValues: this.props.promoCodes,
                    promoCodeFromExternalSource: false,
                    promoCodeQuantityValue: this.props.promoCodes.toString().split(",").length,
                    stateAlreadyCopiedFromProps: true
                });
            }
        }
    }

    componentWillUnmount() {
        // Send the updated state data to the parent component
        const promoCodeValues = (this.state.promoCodeFromExternalSource) ? this.state.promoCodeValuesFromExternalSource : (this.state.promoCodesGeneratedValues) ? this.state.promoCodesGeneratedValues.toString() : '';
        const promotionPromoCodesdata = {
            promoCodeUsageType: (this.state.promoCodeUsageType == '') ? null : this.state.promoCodeUsageType,
            promoCodeFromExternalSource: (this.state.promoCodeUsageType == '') ? null : this.state.promoCodeFromExternalSource,
            promoCodeValues: (this.state.promoCodeUsageType == '') ? null : promoCodeValues,
            promoCodeScreenOpened: true,
            oneTimeDiscount: this.state.oneTimeDiscount,
            oneTimePerCustomer: this.state.oneTimePerCustomer
        }

        this.props.getPageData(promotionPromoCodesdata);
        this.resetState();
    }

    resetState() {
        this.state.promotionId = null;
        this.state.promoCodeUsageType = '';
        this.state.promoCodeFromExternalSource = true;
        this.state.promoCodeValues = '';
        this.state.promoCodeValuesFromExternalSource = '';
        this.state.promoCodesGeneratedValues = '';
        this.state.promoCodeQuantityValue = null;
        this.state.fieldsDisabled = false;
        this.state.invalidForm = false;
        this.state.stateAlreadyCopiedFromProps = false;
    }

    changePromoCodeFromExternalSourceState({ target }) {

        this.setState({
            promoCodeFromExternalSource: !this.state.promoCodeFromExternalSource
        });
    }

    changeFieldState({ target }) {
        this.setState({
            ...this.state,
            [target.name]: (target.name === 'promoCodeQuantityValue') ? Number(target.value) : target.value
        });

        if (target.name == 'promoCodeUsageType' && target.value == '') {
            this.setState({
                ...this.state,
                promoCodeUsageType: '',
                promoCodeValues: '',
                promoCodeValuesFromExternalSource: '',
                promoCodesGeneratedValues: '',
                promoCodeQuantityValue: null,
                fieldsDisabled: false,
                invalidForm: false,
            });
        }
    }

    updateCheckboxState({ target }) {
        this.setState({
            ...this.state,
            [target.name]: target.checked
        });
    }

    generatePromoCodes() {
        // reset promoCodesGeneratedValues
        this.state.promoCodesGeneratedValues = '';

        if (this.state.promoCodeQuantityValue !== undefined && this.state.promoCodeQuantityValue !== null) {
            this.props.generatePromotionCodes(this.state.promoCodeQuantityValue, this.props.restaurantId);

            this.state.stateAlreadyCopiedFromProps = false;
        }
    }

    submitForm() {
        let validFormData = this.handleTabValidation();

        if (validFormData) {
            this.props.goToNextPage();
        }
    }

    handleTabValidation() {
        const { promoCodeUsageType, promoCodeValuesFromExternalSource, promoCodesGeneratedValues, promoCodeFromExternalSource, promoCodeQuantityValue } = this.state;
        let validFormData = true;
        this.state.invalidForm = false;

        if (this.state.fieldsDisabled) {
            return validFormData;
        }

        if (promoCodeUsageType !== '' && promoCodeValuesFromExternalSource.length == 0 && promoCodeFromExternalSource) {
            this.state.invalidForm = true;
            validFormData = false;

            this.props.cancelTabChangeRequest();

            return validFormData;
        }

        if (promoCodeFromExternalSource && promoCodeValuesFromExternalSource !== '' && promoCodeUsageType == '') {
            this.state.invalidForm = true;
            validFormData = false;

            this.props.cancelTabChangeRequest();

            return validFormData;
        }

        if (!promoCodeFromExternalSource && promoCodesGeneratedValues !== '' && promoCodeUsageType == '') {
            this.state.invalidForm = true;
            validFormData = false;

            this.props.cancelTabChangeRequest();

            return validFormData;
        }

        if (!promoCodeFromExternalSource && promoCodeQuantityValue !== null && promoCodeUsageType == '') {
            this.state.invalidForm = true;
            validFormData = false;

            this.props.cancelTabChangeRequest();

            return validFormData;
        }

        if (promoCodeQuantityValue == null && promoCodeUsageType == '' && promoCodeValuesFromExternalSource == '' && promoCodesGeneratedValues == '') {
            return validFormData;
        }

        return validFormData;
    }

    renderPromoCodeUsageType() {
        const { promoCodeUsageTypeColStyle, promoCodeUsageTypeForm } = styles;

        return (
            <Col sm={6} style={promoCodeUsageTypeColStyle}>
                <Form style={promoCodeUsageTypeForm}>
                    <Input type="select" name="promoCodeUsageType" id="promoCodeUsageType"
                        value={this.state.promoCodeUsageType}
                        onChange={this.changeFieldState}
                        invalid={this.state.invalidForm}
                        required={true && !this.state.fieldsDisabled}
                        disabled={this.state.fieldsDisabled}>
                        <option value="">{i18n.t('screens:promoCodesScreen.choosePromoCodeUsageType')}</option>
                        <option value="SINGLE">{i18n.t('screens:promoCodesScreen.singleUsageCode')}</option>
                        <option value="MULTIPLE">{i18n.t('screens:promoCodesScreen.multipleUsageCode')}</option>
                    </Input>
                    <FormFeedback>{i18n.t('common:validations.errorMsg')}</FormFeedback>
                </Form>
            </Col>
        );
    }

    renderPromoCodeRadioBtns() {
        const { radioBtnStyle, radioButtonsContainer, promoCodesRadioBtnsContainer, promoCodeLabel } = styles;

        return (
            <div style={promoCodesRadioBtnsContainer}>
                <Form inline name="promo_codes" style={radioButtonsContainer}>
                    <Input type="radio" name="promo_codes" value="promoCodeFromExternalSource"
                        style={radioBtnStyle}
                        checked={this.state.promoCodeFromExternalSource}
                        onChange={this.changePromoCodeFromExternalSourceState}
                        disabled={this.state.fieldsDisabled}
                    />
                    <Label for="promoCodeFromExternalSource" style={promoCodeLabel}>{i18n.t('screens:promoCodesScreen.promoCodeFromExternalSource')}</Label>

                    <Input type="radio" name="promo_codes" value="generatedPromoCodes"
                        style={radioBtnStyle}
                        checked={!this.state.promoCodeFromExternalSource}
                        onChange={this.changePromoCodeFromExternalSourceState}
                        disabled={this.state.fieldsDisabled}
                    />
                    <Label for="generatedPromoCodes" style={promoCodeLabel}>{i18n.t('screens:promoCodesScreen.generatedPromoCodes')}</Label>
                </Form>
            </div>
        );
    }

    renderPromoCodesFromExternalSource() {
        const { textAreaFormStyle, textAreaStyle } = styles;
        let textAreaName = '';

        if (this.state.promotionId !== -1) {
            textAreaName = 'promoCodeValues';
        } else {
            textAreaName = 'promoCodeValuesFromExternalSource';
        }

        return (
            <Form style={textAreaFormStyle}>
                <Input type="textarea" name={textAreaName} id="promoCodesFromExternalSourceId"
                    value={(this.state.promotionId !== -1) ? this.state.promoCodeValues : this.state.promoCodeValuesFromExternalSource}
                    onChange={this.changeFieldState}
                    placeholder={i18n.t('screens:promoCodesScreen.textAreaPlaceholderExternalSource')}
                    style={textAreaStyle}
                    invalid={this.state.invalidForm && this.state[textAreaName] == ''}
                    required={true && !this.state.fieldsDisabled}
                    disabled={this.state.fieldsDisabled} />
                <FormFeedback>{i18n.t('common:validations.errorMsg')}</FormFeedback>
                <FormGroup check inline>
                    <Label for='oneTimeDiscount' style={{ marginBottom: 0, marginRight: 10 }}>{i18n.t('screens:promoCodesScreen.firstOrderDiscount')}</Label>
                    <Input
                        style={{ marginTop: 1 }}
                        id='oneTimeDiscount'
                        type='checkbox' name='oneTimeDiscount'
                        checked={this.state.oneTimeDiscount}
                        value={this.state.oneTimeDiscount}
                        disabled={this.state.fieldsDisabled || this.state.oneTimePerCustomer}
                        onChange={this.updateCheckboxState.bind(this)} />
                    <Label for='oneTimePerCustomer' style={{ marginBottom: 0 }}>{i18n.t('screens:promoCodesScreen.oneTimeDiscount')}</Label>
                    <Input
                        style={{ marginLeft: 10 }}
                        id='oneTimePerCustomer'
                        type='checkbox' name='oneTimePerCustomer'
                        checked={this.state.oneTimePerCustomer}
                        value={this.state.oneTimePerCustomer}
                        disabled={this.state.fieldsDisabled || this.state.oneTimeDiscount}
                        onChange={this.updateCheckboxState.bind(this)}
                    />
                </FormGroup>
            </Form>
        );
    }

    renderQuantity() {
        const { quantityColStyle, quantityLabelStyle, quantityInputStyle } = styles;

        return (
            <Col sm={4} style={quantityColStyle}>
                <label style={quantityLabelStyle}>{i18n.t('screens:promotionTypeScreen.quantity')}</label>
                <Form>
                    <Input type="number" name="promoCodeQuantityValue" placeholder="number"
                        value={(this.state.promotionId !== -1) ? this.state.promoCodeValues.split(",").length : this.state.promoCodeQuantityValue}
                        onKeyPress={(e) => negativeIntegersValidation(e)}
                        onChange={this.changeFieldState}
                        min={1}
                        style={quantityInputStyle}
                        invalid={this.state.invalidForm && this.state.promoCodeQuantityValue == null}
                        required={true && !this.state.fieldsDisabled && this.state.promoCodeFromExternalSource}
                        disabled={this.state.fieldsDisabled}
                    />
                    <FormFeedback>{i18n.t('common:validations.errorMsg')}</FormFeedback>
                </Form>
            </Col>
        );
    }

    renderGenerateButton() {
        const { generateBtnStyle } = styles;

        return (
            <Col sm={8}>
                <Button color="primary"
                    style={generateBtnStyle}
                    onClick={this.generatePromoCodes}
                    disabled={this.state.fieldsDisabled}>
                    <MaterialIcon icon="refresh" color="#fff" size={20} />
                    &nbsp;{i18n.t('common:buttons.generate')}
                </Button>
            </Col>
        );
    }

    renderGeneratedPromoCodes() {
        const { rowStyle, textAreaFormStyle, textAreaStyle } = styles;
        let textAreaName = '';

        if (this.state.promotionId !== -1) {
            textAreaName = 'promoCodeValues';
        } else {
            textAreaName = 'promoCodesGeneratedValues';
        }

        return (
            <div>
                <Row style={rowStyle}>
                    {this.renderQuantity()}
                    {this.renderGenerateButton()}
                </Row>
                <Form style={textAreaFormStyle}>
                    <Input type="textarea" name={textAreaName} id="promoCodesFromExternalSourceId"
                        value={(this.state.promotionId !== null && this.state.promotionId !== -1) ? this.state.promoCodeValues : this.state.promoCodesGeneratedValues}
                        onChange={this.changeFieldState}
                        placeholder={i18n.t('screens:promoCodesScreen.textAreaPlaceholderGeneratedPromoCodes')}
                        style={textAreaStyle}
                        invalid={this.state.invalidForm && this.state[textAreaName] == ''}
                        required={true && !this.state.fieldsDisabled}
                        disabled={this.state.fieldsDisabled} />
                    <FormFeedback>{i18n.t('common:validations.errorMsg')}</FormFeedback>
                    <FormGroup check inline>
                        <Label check style={{ marginRight: 10 }}>{i18n.t('screens:promoCodesScreen.firstOrderDiscount')}</Label>
                        <Input
                            style={{ marginTop: 1 }}
                            type="checkbox" name="oneTimeDiscount"
                            checked={this.state.oneTimeDiscount}
                            value={this.state.oneTimeDiscount}
                            disabled={this.state.fieldsDisabled}
                            onChange={this.updateCheckboxState.bind(this)} />

                        <Label for='oneTimePerCustomer' style={{ marginBottom: 0 }}>{i18n.t('screens:promoCodesScreen.oneTimeDiscount')}</Label>
                        <Input
                            style={{ marginLeft: 10 }}
                            id='oneTimePerCustomer'
                            type='checkbox' name='oneTimePerCustomer'
                            checked={this.state.oneTimePerCustomer}
                            value={this.state.oneTimePerCustomer}
                            disabled={this.state.fieldsDisabled || this.state.oneTimeDiscount}
                            onChange={this.updateCheckboxState.bind(this)}
                        />
                    </FormGroup>
                </Form>
            </div>
        );
    }

    render() {
        const { formContainer, infoStyle } = styles;

        if (this.props.requestTabChange) {
            this.submitForm();
        }

        this.copyStateFromProps();

        const isMesssageHidden = (this.props.promotionId !== undefined && this.props.promotionId !== null && this.props.promotionId !== -1) ? true : false;

        return (
            <div style={formContainer}>
                <p hidden={isMesssageHidden} style={infoStyle}>{i18n.t('screens:promoCodesScreen.promoCodeStepMessage')}</p>
                {this.renderPromoCodeUsageType()}
                {this.renderPromoCodeRadioBtns()}
                {(this.state.promoCodeFromExternalSource) ? this.renderPromoCodesFromExternalSource() : this.renderGeneratedPromoCodes()}
            </div>
        );
    }
};

const mapStateToProps = state => {
    return {
        promoCodes: state.promoCodes
    };
};

export default connect(mapStateToProps, { generatePromotionCodes })(PromotionPromoCodesScreen);

const styles = {
    formContainer: {
        marginTop: 10,
        paddingTop: 10,
        paddingBottom: 10,
        paddingLeft: 5,
        paddingRight: 5,
        overflowX: 'hidden',
        overflowY: 'auto',
        maxHeight: 300,
        backgroundColor: '#f8f8f8',
        border: '1px solid #E9ECEF'
    },
    radioBtnStyle: {
        position: 'relative',
        top: 0,
        marginLeft: 5,
        marginRight: 5
    },
    radioButtonsContainer: {
        marginBottom: 20
    },
    promoCodesRadioBtnsContainer: {
        marginTop: 10,
        marginLeft: 5,
        marginBottom: 10
    },
    promoCodeLabel: {
        marginRight: 5
    },
    rowStyle: {
        marginBottom: 10
    },
    textAreaFormStyle: {
        margin: '0 5px 0 5px'
    },
    textAreaStyle: {
        height: 80
    },
    quantityColStyle: {
        paddingLeft: 30
    },
    quantityLabelStyle: {
        float: 'left',
        margin: '10px 5px 0px 0px'
    },
    quantityInputStyle: {
        width: '50%'
    },
    infoStyle: {
        fontSize: 12,
        color: 'rgb(183, 183, 183)',
        marginLeft: 10
    },
    generateBtnStyle: {
        float: 'right', marginRight: 5
    },
    promoCodeUsageTypeColStyle: {
        marginLeft: -7
    },
    promoCodeUsageTypeForm: {
        marginBottom: 15
    }
};


// WEBPACK FOOTER //
// ./src/components/restaurants/promotions/PromotionPromoCodesScreen.js